var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Component, Input } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
var ComprobantePopupComponent = (function () {
    function ComprobantePopupComponent(sanitizer) {
        this.sanitizer = sanitizer;
        this.visible = false;
        this.preview = null;
        this.visiblePreview = false;
    }
    ComprobantePopupComponent.prototype.loadCmp = function (cmp) {
        this.comprobante = cmp;
        this.visiblePreview = (this.comprobante ? true : false);
        this.visible = true;
        this.preview = this.sanitizer.bypassSecurityTrustResourceUrl("data:application/pdf;base64," + this.comprobante);
    };
    ComprobantePopupComponent.prototype.finalize = function () {
        this.visible = false;
        this.visiblePreview = false;
    };
    return ComprobantePopupComponent;
}());
__decorate([
    Input(),
    __metadata("design:type", String)
], ComprobantePopupComponent.prototype, "id", void 0);
__decorate([
    Input(),
    __metadata("design:type", String)
], ComprobantePopupComponent.prototype, "comprobante", void 0);
ComprobantePopupComponent = __decorate([
    Component({
        moduleId: module.id,
        selector: 'comprobante-popup',
        templateUrl: 'comprobante-popup.component.html'
    }),
    __metadata("design:paramtypes", [DomSanitizer])
], ComprobantePopupComponent);
export { ComprobantePopupComponent };
//# sourceMappingURL=comprobante-popup.component.js.map